export const langHeader = {
  exit: {
    ua: 'Вихід',
    en: 'Exit',
  },
};
